import { ChevronBottomOutlineIcon } from '@ikyucom/design-system-icons-react'
import clsx from 'clsx'
import { useEffect, useRef, useState } from 'react'
import type { ReactElement } from 'react'
import { css } from '~/styled-system/css'

type Props = {
  children: ReactElement | ReactElement[]
}

const TransparentAccordion: React.FC<Props> = ({ children }) => {
  const [open, setOpen] = useState(false)
  const openAccordion = () => {
    setOpen(true)
  }
  const ref = useRef<HTMLDivElement>(null)
  const [contentHeight, setContentHeight] = useState(0)

  useEffect(() => {
    if (ref.current) {
      setContentHeight(ref.current.getBoundingClientRect().height)
    }
    contentHeight > 100 ? setOpen(false) : setOpen(true)
  }, [contentHeight])

  return (
    <>
      <div className={css({ w: 'full' })}>
        {/* TODO: 小要素に応じてデフォルトで見せるheightを指定できるようにする */}
        <div
          ref={ref}
          className={clsx(open ? '' : css({ overflow: 'hidden' }))}
          style={{ height: open ? '' : '100px' }}
        >
          {children}
        </div>
        {open ? (
          <></>
        ) : (
          <div
            className={css({
              position: 'relative',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            })}
          >
            <button
              type="button"
              className={css({
                position: 'absolute',
                bottom: '0',
                left: '0',
                height: '[80px]',
                width: 'full',
                bgGradient: 'to-b',
                gradientFrom: 'white/0',
                gradientVia: 'white/95',
                gradientViaPosition: '[60%]',
                gradientTo: 'white',
              })}
              onClick={openAccordion}
            >
              <span
                className={css({
                  position: 'absolute',
                  bottom: '3',
                  left: '0',
                  right: '0',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: 'sm',
                  color: 'link',
                  columnGap: '1',
                })}
              >
                もっとみる
                <ChevronBottomOutlineIcon />
              </span>
            </button>
          </div>
        )}
      </div>
    </>
  )
}

export default TransparentAccordion
